import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import bannerTop from './images/aboutUs-banner-top.png';
import bannerFish from './images/aboutUs-banner-fish.png';
import bannerBottom from './images/aboutUs-banner-bottom.png';
import team from './images/team.jpg'
import teamMember1 from './images/team-member1.jpg'
import teamMember2 from './images/team-member2.jpg'
import teamMember3 from './images/team-member3.jpg'
import teamMember4 from './images/team-member4.jpg'
import teamMember5 from './images/team-member5.jpg'
import teamMember6 from './images/team-member6.jpg'
import teamMember7 from './images/team-member7.jpg'
import teamMember8 from './images/team-member8.jpg'
import teamMember9 from './images/team-member9.jpg'
import teamMember10 from './images/team-member10.jpg'
import teamMember11 from './images/team-member11.jpg'
import teamMember12 from './images/team-member12.jpg'
import teamMember13 from './images/team-member13.jpg'
import teamMember14 from './images/team-member14.jpg'
import teamMember15 from './images/team-member15.jpg'
import teamMember16 from './images/team-member16.jpg'
import teamMember17 from './images/team-member17.jpg'
import teamMember18 from './images/team-member18.jpg'
import teamMember19 from './images/team-member19.jpg'
import teamMember20 from './images/team-member20.jpg'
import teamMember21 from './images/team-member21.jpg'
import teamMember22 from './images/team-member22.jpg'
import teamMember23 from './images/team-member23.jpg'
import teamMember24 from './images/team-member24.jpg'
import teamMember25 from './images/team-member25.jpg'
import teamMember26 from './images/team-member26.jpg'
import teamMember27 from './images/team-member27.jpg'
import teamMember28 from './images/team-member28.jpg'
import teamMember29 from './images/team-member29.jpg'
import teamMember30 from './images/team-member30.jpg'
import teamMember31 from './images/team-member31.jpg'
import teamMember32 from './images/team-member32.jpg'
import teamMember33 from './images/team-member33.jpg'
import teamMember34 from './images/team-member34.jpg'
import teamLogo from './images/team-logo.png'

import arrow from './images/join-us-arrow.png'

class AboutUs extends Component {
  constructor(props){
    super(props);
    this.state={
        id:'0'
    }
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }
  componentDidMount(){
    window.scrollTo(0,0);
  }

  onMouseEnter(e){
    this.setState({
        id: e.target.id,
    });
}

onMouseLeave(e){
    this.setState({
        id: '0',
    })
}

  render() {
    return (
      <div className="aboutUs">
          <div className='aboutUs-banner'>
           <p><img className='bannerTop' src={bannerTop} width='441' height='80' alt='新运力形象图'/></p>
           <p className='fish'>
            <img className='fish-icon' src={bannerFish} width='209' height='252' alt='新运力小神鲸'/>
           </p>
           <p >
             <img  src={bannerBottom} alt='新运力形象图' width='288' height='44'/>
           </p>
          </div>

          <div className='aboutUs-intr'>
            <div className='max-width-box'>
              <div className='intro'>
                <div className='flex-item'>
                    <div className='intr-title'>
                      <h3>关于新集运</h3>
                      <span className='line'></span>
                    </div>
                    <p>
                    新集运科技成立于2021年4月，注册于广州市黄埔区，是一家致力于服务内贸集装箱运输行业的互联网科技公司；公司秉承服务集运人的理念，通过 “互联网+”与集运行业深度融合，利用大数据分析、智能交通等先进技术，提升行业效率，降低行业成本，打造集运行业全新生态圈。
                    </p>
                </div>
              </div>
            </div>
          </div>
      </div>

    );
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/pages/aboutUs/index.js